import React from 'react';
import { compose } from 'redux';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { Grid } from '@mui/material';
import { Search } from '@mui/icons-material';
import { IconButton, TextField } from '@totalsoft/rocket-ui';

const ContractSelectionFiltersComponent = ({ t, filters, onChangeFilterValue, loadLeasingContractList }) => {
  return (
    <Grid container spacing={2} alignItems='center' mb={2}>
      <Grid item xs={4}>
        <TextField
          id='contractSelection_filters_uniqueId'
          label={t('RestructuringEdit.ContractSelection.Filters.UniqueId')}
          value={filters ? filters.uniqueId : ''}
          fullWidth
          onChange={onChangeFilterValue('uniqueId')}
        />
      </Grid>
      <Grid item xs={4}>
        <TextField
          id='contractSelection_filters_partnerName'
          label={t('RestructuringEdit.ContractSelection.Filters.PartnerName')}
          value={filters ? filters.partnerName : ''}
          fullWidth
          onChange={onChangeFilterValue('partnerName')}
        />
      </Grid>
      <Grid item>
        <IconButton
          id={'contractCard_searchBtn'}
          tooltip={t('Search')}
          color='primary'
          variant='text'
          size='tiny'
          onClick={loadLeasingContractList}
        >
          <Search />
        </IconButton>
      </Grid>
    </Grid>
  );
};

ContractSelectionFiltersComponent.propTypes = {
  t: PropTypes.func.isRequired,
  filters: PropTypes.object.isRequired,
  onChangeFilterValue: PropTypes.func.isRequired,
  loadLeasingContractList: PropTypes.func.isRequired
};

export default compose(withTranslation())(ContractSelectionFiltersComponent);
